import { render, staticRenderFns } from "./VxList.vue?vue&type=template&id=6fbc134c&functional=true"
import script from "./VxList.vue?vue&type=script&lang=js"
export * from "./VxList.vue?vue&type=script&lang=js"
import style0 from "./VxList.vue?vue&type=style&index=0&id=6fbc134c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports